import { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { PageHeader, Panel, Loading, Kpi, FilterBar, Field, NSelect, useFetch } from "@/components/common";
import { Euro } from "lucide-react";
import { fEur, fNum, fMonth } from "@/lib/api";

const COLORS = { commerciaux: "#0E2D43", technicien: "#7C3AED", logistique: "#2F80ED", administratif: "#94A3B8" };
const MONTHS = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

function Group({ g }) {
  return (
    <Panel title={g.label} testid={`mobility-group-${g.key}`}>
      <div className="flex flex-wrap gap-4 text-sm mb-3">
        <span>Total <b className="text-[#0E2D43]" data-testid={`mobility-${g.key}-total`}>{fEur(g.spend)}</b></span>
        <span>Mooncard <b>{fEur(g.mooncard)}</b></span><span>Fleet Pro <b>{fEur(g.fleetpro)}</b></span>
        <span>Recharge électrique <b>{fEur(g.energy)}</b></span><span><b>{fNum(g.liters, 0)}</b> L · {g.count} opérations</span>
      </div>
      {g.people.length > 0 && (
        <table className="tbl w-full text-xs"><thead><tr><th>Titulaire</th><th>Véhicule(s)</th><th className="text-right">Litres</th><th className="text-right">Dépenses TTC</th></tr></thead>
          <tbody>{g.people.map((p) => <tr key={p.name}><td className="font-semibold">{p.name}</td><td>{p.plates.join(", ") || "—"}</td><td className="text-right tabular-nums">{fNum(p.liters, 1)}</td><td className="text-right tabular-nums font-semibold">{fEur(p.spend)}</td></tr>)}</tbody></table>
      )}
    </Panel>
  );
}

export default function Mobilite() {
  const y = new Date().getFullYear();
  const [f, setF] = useState({ year: String(y) });
  const { data, loading } = useFetch("/mobility/overview", f);
  return (
    <div data-testid="mobility-page">
      <PageHeader overline="Véhicules commerciaux · Direction" title="Dépenses mobilité / énergie" />
      <FilterBar testid="mobility-filters">
        <Field label="Année"><NSelect value={f.year} onChange={(v) => setF({ ...f, year: v })} placeholder="Toutes" testid="mobility-year" options={[y, y - 1].map((x) => ({ value: String(x), label: String(x) }))} /></Field>
        <Field label="Mois"><NSelect value={f.month} onChange={(v) => setF({ ...f, month: v })} placeholder="Tous" testid="mobility-month" options={MONTHS.map((m, i) => ({ value: String(i + 1), label: m }))} /></Field>
      </FilterBar>
      {loading || !data ? <Loading /> : (
        <div className="space-y-6">
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
            <Kpi testid="mobility-total" label="Total mobilité / énergie" value={fEur(data.total, 0)} icon={Euro} tone="navy" />
            {data.groups.map((g) => <Kpi key={g.key} testid={`mobility-kpi-${g.key}`} label={g.label} value={fEur(g.spend, 0)} icon={Euro} />)}
          </div>
          <Panel title="Évolution mensuelle par catégorie de collaborateurs" testid="mobility-monthly">
            <div className="h-64"><ResponsiveContainer><BarChart data={data.monthly}><CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
              <XAxis dataKey="month" tickFormatter={fMonth} tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 11 }} width={60} /><Tooltip labelFormatter={fMonth} formatter={(x) => fEur(x)} /><Legend />
              {data.groups.map((g) => <Bar key={g.key} dataKey={g.key} name={g.label} stackId="s" fill={COLORS[g.key]} />)}
            </BarChart></ResponsiveContainer></div>
          </Panel>
          <div className="grid lg:grid-cols-2 gap-6">{data.groups.map((g) => <Group key={g.key} g={g} />)}</div>
        </div>
      )}
    </div>
  );
}
